import styled from 'styled-components';
import {CardBtnGroup} from './CardBtnGroup';
import {conditionDeletableCard} from '../card-conditions/conditionDeletableCard';
import {conditionCardShadow} from '../card-conditions/conditionCardShadow';
import {conditionCardSize} from '../card-conditions/conditionCardSize';
import {FixedSidebar} from '../../../custom-feature/fixed-sidebar/FixedSidebar';
import {
    formControlColors,
    inContainerFormControlColors,
} from '../../../../shared-components/variables/componentColors/formControlVariableColors';
import {colorTheme} from '../../../mixin/colorTheme';
export const CardWrapper = styled.div`
    ${inContainerFormControlColors};
    position: relative;
    border-radius: 8px;
    margin-bottom: var(--space-sm);
    background: var(--card-body-background-color-100);
    color: var(--card-text-color-100);
    box-shadow: var(--container-shadow-color-100);
    border: 1px solid var(--container-border-color-500);

    ${FixedSidebar} & {
        background: var(--card-body-background-color-200);
        box-shadow: var(--container-shadow-color-200);
        ${formControlColors()};
        ${colorTheme({
            '--card-sidebar-input-background-color': {dark: 'var(--black-04)', light: 'var(--white-00)'},
            '--card-sidebar-input-border-color': {dark: 'var(--black-02)', light: 'var(--gray-02)'},
        })};
        --form-control-background-color: var(--card-sidebar-input-background-color);
        --form-control-border-color: var(--card-sidebar-input-border-color);
        --form-word-fix-border-color: var(--card-sidebar-input-border-color);
    }

    ${({hoverCornerBtn}) => {
        if (hoverCornerBtn)
            return `
            ${CardBtnGroup} {
                display: none;
            }
            &:hover{
                ${CardBtnGroup} {
                    display: flex;
                }
            }
        `;
    }}

    ${({deletable}) => conditionDeletableCard(deletable)};
    ${({shadow}) => conditionCardShadow(shadow)};
    ${({size}) => conditionCardSize(size)};
`;
